import React from "react";
import { useImmer } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import { PersonalizationOfferType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetOffersExperienceList } from "@src/api/offers/get-offers-experience-list";
import { getMixpanelStepTitle } from "@src/components/MainApp/Onboarding/utils";
import { OffersMarketingBanner } from "@src/components/OffersMarketingBanner";
import { OffersTable } from "@src/features/offers/components/OffersTable";
import { StartFromScratchCards } from "@src/features/offers/components/StartFromScratchCards";
import { SharedTableHeader } from "@src/features/sharedExperience/components/SharedTableHeader";
import { useViewPage } from "@src/hooks/mixpanel";

export const OffersBody = () => {
  const [searchInput, setSearchInput] = useImmer<string>("");
  const offerPersonalizationsData = useGetOffersExperienceList();
  const [statusFilters, setStatusFilters] = useImmer<string[]>([]);
  const [typeFilters, setTypeFilters] = useImmer<PersonalizationOfferType[]>(
    []
  );
  useViewPage("Offers");

  return (
    <Grid container rowSpacing={8}>
      <OffersMarketingBanner />
      <StartFromScratchCards renderLocation={"offers"} />
      <SharedTableHeader
        title={"Offers"}
        experienceData={offerPersonalizationsData}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        statusFilters={statusFilters}
        setStatusFilters={setStatusFilters}
        typeFilters={typeFilters}
        setTypeFilters={setTypeFilters}
        statusFilterListOptions={["Active", "Inactive", "Archived"]}
        typeFilterListOptions={
          [
            "Volume Discount",
            "Amount off Products",
            "Amount off Order",
            "Free Gift",
            "Free Shipping",
          ] as PersonalizationOfferType[]
        }
      />

      <OffersTable
        searchInput={searchInput}
        offerPersonalizationsData={offerPersonalizationsData}
        statusFilters={statusFilters}
        typeFilters={typeFilters}
      />
    </Grid>
  );
};
